import React from 'react'
import INRFundReport from '../../Component/DepositFund/INRFundReport/INRFundReport'

const RequestfundINR = () => {
  return (
    <div className='page-body'>
      <INRFundReport/>
    </div>
  )
}

export default RequestfundINR